import React from "react";
import "./AnalyticsConsentSheet.css";

export default function AnalyticsConsentSheet({
    open,
    onAccept,
    onDecline,
    onClose,              // NEW optional
    mode = "gate",        // NEW: "gate" or "settings"
  }) {
    if (!open) return null;
  
    const allowDismiss = mode === "settings";
  
    return (
      <div
        className="acs-backdrop"
        role="dialog"
        aria-modal="true"
        aria-labelledby="acs-title"
        aria-describedby="acs-desc"
        onClick={allowDismiss ? onClose : onDecline}
      >
        <div className="acs-sheet" onClick={(e) => e.stopPropagation()}>
          <div className="acs-handle" />
  
          <h2 className="acs-title" id="acs-title">
            Ajude a melhorar o app
          </h2>
  
          <p className="acs-text" id="acs-desc">
            Compartilhe dados anônimos de uso para melhorar a experiência.
          </p>
  
          <div className="acs-buttons">
            <button className="acs-btn acs-btn--secondary" type="button" onClick={onDecline}>
              Não, obrigado
            </button>
            <button className="acs-btn acs-btn--primary" type="button" onClick={onAccept}>
              Permitir
            </button>
          </div>
  
          {allowDismiss && (
            <button className="acs-link" type="button" onClick={onClose}>
              Fechar
            </button>
          )}
        </div>
      </div>
    );
  }